import { BasePageThemeType, BaseThemeType,BaseSizesType, BaseSettings } from 'Shared/frontend/themes/BaseSettings';
import {createContext,JSX,useContext} from 'solid-js';

/*
	See https://stackoverflow.com/questions/61132262/typescript-deep-partial for alternatives.
	type-fest looks very popular
*/
export type DeepPartial<T> = T extends object ? {
    [P in keyof T]?: DeepPartial<T[P]>;
} : T;


const ThemeContext = createContext();

//XXX currently calling this in 2 different ways and times:
// 1. In BackendWrap to provide settings
// 2. Around previewers, where siteTheme and settingsPageName are added
// There's probably a cleaner way to structure this.

export function SettingsProvider(P:{settings:BaseSettings,siteTheme?:BaseThemeType,settingsPageName?:(() => string)} & {children:JSX.Element})
{
	return (
		<ThemeContext.Provider value={P}>
			{P.children}
		</ThemeContext.Provider>
	);
}

export function theme():BasePageThemeType
{
	const context = useContext(ThemeContext);
	return context.siteTheme[context.settingsPageName()] ?? context.siteTheme.page;
}

export function useSettingsPageName()
{
	const context = useContext(ThemeContext);
	return context?.settingsPageName;
}


export function useSettings():BaseSettings
{
	return useContext(ThemeContext).settings;
}

export function settingsExists():BaseSettings
{
	return useContext(ThemeContext)?.settings != undefined && useContext(ThemeContext)?.settingsPageName != undefined;
}

export function siteTheme():BasePageThemeType
{
	return useContext(ThemeContext).siteTheme;
}

export function palette()
{
	return useContext(ThemeContext).siteTheme.palette;
}

export function fonts()
{
	return useContext(ThemeContext).siteTheme.fonts;
}

export function sizes(): BaseSizesType
{
	return useContext(ThemeContext).siteTheme.sizes;
}

